/* eslint-disable default-param-last */
import { get } from 'store/api'

const actions = {
  SET_BROKEN_LINKS_COUNT: 'SET_BROKEN_LINKS_COUNT',
}

export const fetchBrokenLinksCount = () => async (dispatch, state) => {
  const { clients, servername } = state()
  const currentClient = clients.find((client) => client.name === servername)

  const count = await get(`${process.env.REACT_APP_HEADERS_DOMAIN}/api/${currentClient.id}/links/broken?count=1`)

  dispatch({
    type: actions.SET_BROKEN_LINKS_COUNT,
    count,
  })
}

export default function brokenLinksReducer(state = {}, action) {
  switch (action.type) {
    case actions.SET_BROKEN_LINKS_COUNT:
      return {
        ...state,
        count: action.count,
      }
    default:
      return state
  }
}
